import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UserLoginComponent } from './user-login/user-login.component'
import { UserViewComponent } from './user-view/user-view.component'
import { UserEditComponent } from './user-edit/user-edit.component'

const ROUTES: Routes = [
	{
		path: 'user/signin',
		component: UserLoginComponent
	},
	{
		path: 'user/view/:username',
		component: UserViewComponent
	},
	{
		path: 'user/edit/:uid',
		component: UserEditComponent
	},
]

@NgModule({
	imports: [
		RouterModule.forChild(ROUTES)
	],
	exports: [
		RouterModule
	]
})

export class UserRoutingModule { }



// WEBPACK FOOTER //
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/user/user-routing.module.ts